module.exports = __webpack_public_path__ + "img/logo-main-clasworld.6441b770.png";